// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

import { ComponentRoundedImageFragmentDoc } from './component/ComponentRoundedImage.fragment.generated';
import { CmsImageSizesFragmentDoc } from './cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from './imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from './imageSize.fragment.generated';
import { ComponentRoundedImageContentFragmentDoc } from './component/ComponentRoundedImageContent.fragment.generated';
import { ContentComponentItemFragmentDoc } from './component/ContentComponentItem.fragment.generated';
import { ComponentTitleFragmentDoc } from './component/content/ContentTitle.fragment.generated';
import { ComponentTitleComponentFragmentDoc } from './component/content/componentTitleComponent.fragment.generated';
import { ComponentTitleAmpersandFragmentDoc } from './component/content/componentTitleAmpersand.fragment.generated';
import { ComponentTitleTextFragmentDoc } from './component/content/componentTitleText.fragment.generated';
import { ComponentTextFragmentDoc } from './component/content/ContentText.fragment.generated';
import { ComponentButtonFragmentDoc } from './component/content/ContentButton.fragment.generated';
import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from './index.generated';
import { ComponentSpacerFragmentDoc } from './component/content/ContentSpacer.fragment.generated';
import { ComponentImageFragmentDoc } from './component/content/ContentImage.fragment.generated';
import { ComponentOrderedListFragmentDoc } from './component/content/ContentOrderedList.fragment.generated';
import { OrderedListItemFragmentDoc } from './component/content/orderedListItem.generated';
import { ComponentContentFragmentDoc } from './component/ComponentContent.fragment.generated';
import { ComponentCardFragmentDoc } from './component/CardComponent.fragment.generated';
import { ComponentTextOverImageFragmentDoc } from './component/ComponentTextOverImage.fragment.generated';
import { ComponentCustomProductCarouselFragmentDoc } from './component/ComponentCustomProductCarousel.fragment.generated';
import { CustomProductCarouselCardFragmentDoc } from './component/carousel/card/CustomProductCarouselCard.fragment.generated';
import { ComponentCatalogueProductCarouselFragmentDoc } from './component/ComponentCatalogueProductCarousel.fragment.generated';
import { ProductCardFragmentDoc } from '../layout/cards/ProductCard.fragment.generated';
import { ProductLinkFragmentDoc } from '../../router/fragments/productLink.fragment.generated';
import { EngagementRingLinkFragmentDoc } from '../../router/fragments/engagementRingLink.fragment.generated';
import { JewelleryLinkFragmentDoc } from '../../router/fragments/jewelleryLink.fragment.generated';
import { ReadyToGoRingLinkFragmentDoc } from '../../router/fragments/readyToGoRingLink.fragment.generated';
import { WeddingRingLinkFragmentDoc } from '../../router/fragments/weddingRingLink.fragment.generated';
import { MetalVariationFragmentDoc } from '../rings/MetalVariations.generated';
import { MetalFilterMetalFragmentDoc } from '../../graphql/api/product/rings/fragments/filters/metalFilter.fragment.generated';
import { GetIsLabGrownFragmentDoc } from '../../domain/product/getIsLabGrown.generated';
import { MoneyFragmentDoc } from '../../graphql/api/fragments/money.fragment.generated';
import { MonolithImageSizeFragmentDoc } from '../monolithImageSize.fragment.generated';
import { ComponentReviewCarouselFragmentDoc } from './component/ComponentReviewCarousel.fragment.generated';
import { ComponentMainCoverFragmentDoc } from './component/ComponentMainCover.fragment.generated';
import { VideoFragmentDoc } from './video.fragment.generated';
import { ComponentVideoFragmentDoc } from './component/ComponentVideo.fragment.generated';
import { ComponentVideoWithContentFragmentDoc } from './component/ComponentVideoWithContent.fragment.generated';
import { ComponentInstagramPostsFragmentDoc } from './component/ComponentInstagramPosts.fragment.generated';
import { ComponentLogosFragmentDoc } from './component/ComponentLogos.fragment.generated';
import { ComponentLogosCarouselFragmentDoc } from './component/ComponentLogosCarousel.fragment.generated';
import { ComponentTextWithImageFragmentDoc } from './component/ComponentTextWithImage.fragment.generated';
import { ComponentGalleryCarouselFragmentDoc } from './component/ComponentGalleryCarousel.fragment.generated';
import { GalleryCarouselCardFragmentDoc } from './component/carousel/card/GalleryCarouselCard.fragment.generated';
import { ComponentCardCarouselFragmentDoc } from './component/carousel/card/ComponentCardCarousel.fragment.generated';
import { CardCarouselCardFragmentDoc } from './component/carousel/card/CardCarouselCard.fragment.generated';
import { ComponentFullWidthImageFragmentDoc } from './component/ComponentFullWidthImage.fragment.generated';
import { ComponentSideBySideImagesFragmentDoc } from './component/ComponentSideBySideImages.fragment.generated';
import { ComponentSideBySideImageFragmentDoc } from './component/side-by-side-images/ComponentSideBySideImage.fragment.generated';
import { ComponentArticlePreviewsFragmentDoc } from './component/ComponentArticlePreviews.fragment.generated';
import { ArticlePreviewFragmentDoc } from './component/article-previews/ArticlePreview.fragment.generated';
import { ComponentInstagramWithContentFragmentDoc } from './component/ComponentInstagramWithContent.fragment.generated';
import { ComponentBannerTitleFragmentDoc } from './component/ComponentBannerTitle.fragment.generated';
import { ComponentQuoteFragmentDoc } from './component/ComponentQuote.fragment.generated';
import { ComponentBannerSkinnyFragmentDoc } from './component/ComponentBannerSkinny.fragment.generated';
import { ComponentGlobalSpacerFragmentDoc } from './component/ComponentGlobalSpacer.fragment.generated';
import { ComponentTextWithImageCarouselFragmentDoc } from './component/ComponentTextWithImageCarousel.fragment.generated';
import { ComponentContentWithGalleryFragmentDoc } from './component/ComponentContentWithGallery.fragment.generated';
import { ComponentIconCarouselFragmentDoc } from './component/ComponentIconCarousel.fragment.generated';
import { ComponentTextCarouselFragmentDoc } from './component/ComponentTextCarousel.fragment.generated';
import { ComponentFaqFragmentDoc } from './component/ComponentFaq.fragment.generated';
import { FaqSectionFragmentDoc } from './component/faq/FaqSection.fragment.generated';
import { FaqQuestionFragmentDoc } from './component/faq/FaqQuestion.fragment.generated';
import { ComponentContentTwoColumnsFragmentDoc } from './component/ComponentContentTwoColumns.fragment.generated';
import { ComponentTableFragmentDoc } from './component/ComponentTable.fragment.generated';
import { ComponentArticleGridFragmentDoc } from './component/ComponentArticleGrid.fragment.generated';
import { ArticleGridItemFragmentDoc } from './component/article-grid/ArticleGridItem.fragment.generated';
import { ComponentOnThisPageFragmentDoc } from './component/ComponentOnThisPage.fragment.generated';
import { ComponentGalleryWithEnquiryFragmentDoc } from './component/gallery-with-enquiry/componentGalleryWithEnquiry.fragment.generated';
import { GalleryWithEnquiryCardFragmentDoc } from './component/gallery-with-enquiry/galleryWithEnquiryCard.fragment.generated';
import { ComponentSquareBoxesFragmentDoc } from './component/square-boxes/ComponentSquareBoxes.fragment.generated';
import { SquareBoxesFragmentDoc } from './component/square-boxes/squareBoxes.fragment.generated';
import { SquareTextBoxFragmentDoc } from './component/square-boxes/SquareTextBox.fragment.generated';
import { SquareImageBoxFragmentDoc } from './component/square-boxes/SquareImageBox.fragment.generated';
import { ComponentShopWithConfidenceFragmentDoc } from './component/ComponentShopWithConfidence.generated';
import { ComponentWarrantyActivationFormFragmentDoc } from './component/ComponentWarrantyActivationForm.fragment.generated';
import { ComponentJobsFragmentDoc } from './component/ComponentJobs.fragment.generated';
import { ComponentJobsJobFragmentDoc } from './component/ComponentJobsJob.fragment.generated';
import { ComponentLogosWithTextFragmentDoc, LogoWithTextFragmentDoc } from './component/ComponentLogosWithText.fragment.generated';
export const ComponentsFragmentDoc = `
    fragment components on Component {
  __typename
  ...componentRoundedImage
  ...componentRoundedImageContent
  ...componentContent
  ...componentCard
  ...componentTextOverImage
  ...componentRoundedImage
  ...componentCustomProductCarousel
  ...componentCatalogueProductCarousel
  ...componentReviewCarousel
  ...componentMainCover
  ...componentVideo
  ...componentVideoWithContent
  ...componentInstagramPosts
  ...componentLogos
  ...componentLogosCarousel
  ...componentTextWithImage
  ...componentGalleryCarousel
  ...componentCardCarousel
  ...componentFullWidthImage
  ...componentSideBySideImages
  ...componentArticlePreviews
  ...componentInstagramWithContent
  ...componentBannerTitle
  ...componentQuote
  ...componentBannerSkinny
  ...componentGlobalSpacer
  ...componentTextWithImageCarousel
  ...componentContentWithGallery
  ...componentIconCarousel
  ...componentTextCarousel
  ...componentFaq
  ...componentContentTwoColumns
  ...componentTable
  ...componentArticleGrid
  ...componentOnThisPage
  ...componentGalleryWithEnquiry
  ...componentSquareBoxes
  ...componentShopWithConfidence
  ...componentWarrantyActivationForm
  ...componentJobs
  ...ComponentLogosWithText
}
    `;